"use strict";
/**
 * 用户信息
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cookie_1 = __importDefault(require("../cookie"));
/**
 * 用户
 */
var user = {
    /**
     * 获取用户信息
     */
    get: function () {
        if (cookie_1.default.get('ut') && cookie_1.default.get('ct') && cookie_1.default.get('uidal')) {
            return {
                id: cookie_1.default.get('uidal').substring(0, 16),
                nick: cookie_1.default.get('uidal').substring(16)
            };
        }
        return null;
    },
    /**
     * 退出登录
     * @param  {function} 退出之后回调
     */
    logOut: function (callback) {
        var date = new Date();
        document.cookie = "pi=;path=/;domain=eastmoney.com;expires=" + date.toUTCString();
        document.cookie = "ct=;path=/;domain=eastmoney.com;expires=" + date.toUTCString();
        document.cookie = "ut=;path=/;domain=eastmoney.com;expires=" + date.toUTCString();
        document.cookie = "uidal=;path=/;domain=eastmoney.com;expires=" + date.toUTCString();
        if (callback) {
            callback();
        }
    },
    isLogin: function () {
        if (this.get()) {
            return true;
        }
        else {
            return false;
        }
    },
    /**
     * 当前打开用
     */
    gotoLogin: function () {
        var loginurl = 'https://passport2.eastmoney.com/pub/login?backurl=' + encodeURIComponent(self.location.href);
        self.location.href = loginurl;
    },
    /**
     * 外跳用
     */
    gotoLogin2: function () {
        var loginurl = 'https://passport2.eastmoney.com/pub/login?backurl=' + encodeURIComponent(self.location.href);
        self.open(loginurl);
    },
    getUserInfo: function () {
        try {
            var pi = cookie_1.default.get('pi');
            var ut = cookie_1.default.get('ut');
            var ct = cookie_1.default.get('ct');
            if (!ut || !ct) {
                return false;
            }
            if (!pi) {
                return false;
            }
            var userInfo = pi.split(';');
            return userInfo;
        }
        catch (error) {
            return false;
        }
    },
    /**
     * 获取用户名
     */
    getUserName: function () {
        if (!this.getUserInfo()) {
            return '';
        }
        return (this.getUserInfo())[2];
    },
    /**
     * 获取用户id
     */
    getUserId: function () {
        if (!this.getUserInfo()) {
            return '';
        }
        return (this.getUserInfo())[0];
    }
};
exports.default = user;
//# sourceMappingURL=data:application/json;base64,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